import moment from 'moment';

// Set relative time thresholds
moment.relativeTimeThreshold('s', 60);
moment.relativeTimeThreshold('ss', 1);
moment.relativeTimeThreshold('m', 60);
moment.relativeTimeThreshold('h', 24);
moment.relativeTimeThreshold('d', 31);
moment.relativeTimeThreshold('M', 12);

moment.relativeTimeRounding(Math.ceil);

moment.locale('en', {
  relativeTime: {
    future: 'in %s',
    past: '%s ago',
    s: '%d second',
    ss: '%d seconds',
    m: '%d minute',
    mm: '%d minutes',
    h: '%d hour',
    hh: '%d hours',
    d: '%d day',
    dd: '%d days',
    M: '%d month',
    MM: '%d months',
    y: '%d year',
    yy: '%d years'
  }
});

moment.defineLocale('en-short', {
  relativeTime: {
    future: 'in %s',
    past: '%s ago',
    s: 'a sec',
    ss: '%d secs',
    m: 'a min',
    mm: '%d mins',
    h: 'an hr',
    hh: '%d hrs',
    d: 'a day',
    dd: '%d days',
    M: 'a month',
    MM: '%d months',
    y: 'a year',
    yy: '%d years'
  }
});


export const dateFormat = 'Y-MM-DD HH:mm:ss';


// WEBPACK FOOTER //
// ./resources/assets/js/app/moment.config.js